var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"menu"},[_c('li',[_c('a',{class:_vm.menuclass()},[_vm._v(_vm._s(_vm.xtitle))]),_vm._v(" "),_c('ul',{staticClass:"dropdown",style:(_vm.getstyle())},_vm._l((_vm.items),function(x,key){return _c('li',{key:key,class:_vm.getlineclass(x.des),on:{"click":function($event){return _vm.select(x)}}},[_vm._v("\n        "+_vm._s(_vm.getdes(x))+"\n      ")])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53ffb3ed","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/_eng/globals/dmenu.vue
// module id = 1624
// module chunks = 172